module.exports = __webpack_public_path__ + "static/media/drpdwnArrow.980301ec.svg";